module.exports = __webpack_public_path__ + "img/launch.bc324d84.png";